import React from "react";
const ErrorMag = ({  errorMagData , setBalError  }) => {
    return (    
        <>
      <div className="error_mag">
            <div className="error_mag_container">
                    <div className="error_mag_container_wrapper">
                        <h1 className="error_mag_container_wrapper_heading">
                            {errorMagData.err_title}
                        </h1>
                        <p className="error_mag_container_wrapper_p">
                            {errorMagData.err_desc}
                        </p>
                        <div className="error_mag_container_wrapper_icon">
                            {/* check for the errorMagData.errorMagData.err_name to conditionally render the icon */}
                                { 
                                    ((errorMagData.err_name) === "insufficient_bal" || (errorMagData.err_name) === "invalid_bal") ? 
                                        <svg xmlns="http://www.w3.org/2000/svg" width="75.85" height="78.698" viewBox="0 0 75.85 78.698"><g id="Group_172898" errorMagData-name="Group 172898" transform="translate(-245.206 -369.288)"><path id="Wallet" d="M73.979,46.746V36.813A6.594,6.594,0,0,0,67.4,30.232H63.68l4.532-4.518a1.425,1.425,0,0,0,.393-.963,1.357,1.357,0,0,0-.393-.963L50.668,6.242a1.357,1.357,0,0,0-1.927,0l-3.27,3.27L32.7,3.135a1.465,1.465,0,0,0-1.045-.068,1.438,1.438,0,0,0-.787.678l-13.2,26.487H9.527A6.594,6.594,0,0,0,3,36.813V75.118A6.595,6.595,0,0,0,9.581,81.7H67.4a6.595,6.595,0,0,0,6.581-6.581V62.906a5.048,5.048,0,0,0,4.871-5.021V51.78a5.034,5.034,0,0,0-4.871-5.034ZM49.7,9.119,65.336,24.71l-5.428,5.428H54.915l1.357-1.275a1.357,1.357,0,0,0,0-1.927,3.216,3.216,0,0,1,0-4.559,1.357,1.357,0,0,0,0-1.927l-2.388-2.2a1.357,1.357,0,0,0-1.913,0,3.2,3.2,0,0,1-4.546,0,1.357,1.357,0,0,0-1.927,0L33.53,30.232H28.591Zm-12.2,21.018a4.844,4.844,0,0,1,6.784,0l.109.136H37.357Zm10.217.136a7.2,7.2,0,0,0-1.452-2.062,7.544,7.544,0,0,0-4.708-2.144L46.57,21.06a5.971,5.971,0,0,0,6.255,0l.611.6a5.888,5.888,0,0,0-.9,3.053,5.821,5.821,0,0,0,.909,3.121l-2.361,2.361ZM30.531,24.452l2.985-6a5.958,5.958,0,0,0,3.121-.109ZM32.7,6.175l10.747,5.36L40.844,14.14l-1.208-.624a1.357,1.357,0,0,0-1.832.611,3.2,3.2,0,0,1-4.3,1.438,1.357,1.357,0,0,0-1.818.6L24.629,30.232H20.707ZM67.4,78.986H9.581a3.881,3.881,0,0,1-3.867-3.867V36.813a3.881,3.881,0,0,1,3.867-3.867H67.4a3.881,3.881,0,0,1,3.867,3.867v9.919H61.143A4.071,4.071,0,0,0,57.072,50.8v8.019a4.071,4.071,0,0,0,4.071,4.071H71.265V75.1A3.881,3.881,0,0,1,67.4,78.986ZM59.786,53.3h1.235a1.52,1.52,0,0,1,0,3.026H59.786Zm16.283,4.559a2.334,2.334,0,0,1-2.32,2.32H61.143a1.357,1.357,0,0,1-1.357-1.14H60.98a4.234,4.234,0,0,0,0-8.453H59.786a1.357,1.357,0,0,1,1.357-1.14H73.816a2.32,2.32,0,0,1,2.32,2.307Z" transform="translate(242.206 366.286)" fill="#ff1b1b" /></g> </svg>
                                    : <></>
                                }
    
                        </div>
                        <div className="error_mag_container_wrapper_ammounts">
                            {/* place any other info here */}
                            { (errorMagData.err_name) === "insufficient_bal" ? 
                                <>
                                    <p className="error_mag_container_wrapper_ammounts_1">
                                        Wallet balance: <b>{"KES " +errorMagData.err_w_bal}</b>
                                    </p>
                                    <p className="error_mag_container_wrapper_ammounts_1 ">
                                            Order total cost: <b err="err">{errorMagData.order_amt}</b>
                                    </p>
                                </>
                                : <></>
                            }

                            { (errorMagData.err_name) === "invalid_bal" ? 
                                <>
                                    <p className="error_mag_container_wrapper_ammounts_1">
                                        Wallet balance: <b>{"KES " +errorMagData.err_w_bal}</b>
                                    </p>
                                </>
                                : <></>
                            }
                        </div>
                        <button className="error_mag_container_wrapper_btn" onClick={()=> setBalError(false)}>
                            OK
                        </button>
                    </div>
                </div>
            </div>
   
            </>
    );
  }

  export default ErrorMag;
